import {UnityEvent} from "../model/UnityConstant";

function NavigateToLoginHandler(unityContext, history) {
    unityContext.on(UnityEvent.NavigateToLogin, () => {
        history.replace("/login");
    });
}

export default NavigateToLoginHandler;